var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLuggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2527 4896 c-70 -19 -125 -63 -161 -126 l-31 -55 -3 -327 -3 -328 100 0 101 0 0 305 c0 292 1 306 20 325 19 19 33 20 409 20 l390 0 20 -26 c20 -26 21 -38 21 -325 l0 -299 95 0 95 0 0 323 c0 316 -1 323 -24 372 -12 28 -40 65 -61 84 -77 67 -68 66 -515 68 -310 2 -416 -1 -453 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267 3919 c-91 -22 -160 -78 -199 -164 l-23 -50 -3 -1379 c-1 -884 1 -1399 8 -1433 5 -30 17 -69 25 -87 23 -48 82 -105 135 -130 45 -21 51 -21 845 -21 l800 0 51 27 c29 15 68 46 88 69 71 83 67 -22 64 1554 l-3 1420 -29 53 c-32 57 -81 102 -143 130 -35 16 -101 17 -808 19 -432 1 -787 -3 -808 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3090 3927 c0 -3 16 -28 35 -57 69 -103 65 -1 65 -1586 0 -1408 0 -1434 -20 -1487 -11 -29 -33 -74 -50 -100 l-30 -47 93 0 c54 0 115 6 144 15 67 20 143 88 172 154 l21 50 -2 1433 -3 1433 -27 46 c-60 101 -135 139 -290 147 -59 3 -108 2 -108 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3589 3871 c76 -118 72 -31 69 -1616 l-3 -1410 -23 -56 c-12 -31 -36 -76 -53 -99 l-31 -42 129 4 c115 3 133 6 179 30 29 15 68 46 88 69 71 83 67 -22 64 1554 l-3 1420 -22 41 c-35 66 -70 101 -129 130 -49 24 -71 28 -180 32 l-125 5 40 -62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3895 554 c-27 -13 -55 -24 -62 -24 -22 0 -62 -60 -68 -104 -12 -77 29 -157 98 -193 40 -20 124 -20 164 0 58 30 103 106 103 172 -1 56 -66 143 -123 164 -39 15 -55 13 -112 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064 538 c-51 -45 -78 -108 -69 -163 7 -48 37 -98 76 -127 23 -18 107 -43 115 -35 2 2 -7 23 -19 48 -34 69 -36 190 -3 270 5 10 -1 19 -19 27 -36 17 -40 16 -81 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 478 c-44 -96 -9 -196 84 -245 69 -36 174 -10 224 55 37 48 43 151 13 200 l-21 32 -140 0 -141 0 -19 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2494 495 c-66 -101 -9 -244 111 -274 26 -6 49 -10 52 -7 2 2 -6 24 -18 48 -19 35 -23 59 -24 128 0 47 4 95 8 108 8 21 6 22 -52 22 -53 0 -62 -3 -77 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2761 477 c-25 -51 -27 -94 -6 -145 32 -76 90 -115 173 -115 98 0 174 77 176 177 0 35 -6 63 -20 86 l-20 35 -141 3 -141 3 -21 -44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3510 488 c-25 -41 -27 -126 -4 -175 21 -43 67 -78 123 -93 23 -6 45 -10 47 -8 2 2 -8 33 -23 68 -22 54 -25 75 -20 134 2 39 8 79 12 89 6 15 0 17 -54 17 -58 0 -62 -2 -81 -32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggage);
export default __webpack_public_path__ + "static/media/luggage.96d46de7f9d179e5059b43f8a8ba833d.svg";
export { ForwardRef as ReactComponent };